import classnames from 'classnames';
import UserAvatar from './UserAvatar';
import UserActivityStatus from './UserActivityStatus';

interface UserAvatarWithActivityStatusProps {
  size: string;
  avatar: any;
  activityStatus: any;
  className?: string;
}

const UserAvatarWithActivityStatus = ({ size, avatar, activityStatus, className }: UserAvatarWithActivityStatusProps) => {

  return <div className={classnames('user-avatar-with-activity-status', `user-avatar-with-activity-status-${size}`, className)}>
    <UserAvatar {...avatar} size={size} />
    <UserActivityStatus {...activityStatus} size={size} hideText={true} />
  </div>
}

export default UserAvatarWithActivityStatus;